import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-east-1_ncTcY0XtI',
    ClientId: 'qr3al1bdfqhuibjdpftgmhr77'
};

export default new CognitoUserPool(poolData);